import { HttpClient } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { Component, input, OnInit, signal } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { IVersion } from '@app/shared/models/version.model';
import { environment } from '@env/environment';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { StorageService } from '@app/core/services/client-services/storage-service/storage.service';
import { MatTooltip } from '@angular/material/tooltip';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-unauth-footer',
    templateUrl: './unauth-footer.component.html',
    styleUrls: ['./unauth-footer.component.scss'],
    imports: [MatTooltip, RouterLink, TranslateModule],
})
export class UnauthFooterComponent implements OnInit {
    page = input<string>();

    availableLanguages = environment.availableLanguages.filter(
        lang => lang.code === 'de' || lang.code === 'en'
    );
    versionString = signal('');

    footerLinks = [
        {
            translationKey: 'GENERAL.IMPRINT',
            link: 'https://www.t-systems.com/de/de/impressum',
        },
        {
            translationKey: 'GENERAL.PRIVACY_POLICY',
            link: 'https://www.t-systems.com/de/de/datenschutz',
        },
        {
            translationKey: 'GENERAL.T',
            link: 'https://www.t-systems.com/de/de',
        },
        {
            translationKey: 'GENERAL.GITHUB',
            link: 'https://github.com/JR-2022/C4L-Addons/tree/main',
        },
    ];

    constructor(
        private translate: TranslateService,
        public appConfig: AppConfig,
        private http: HttpClient,
        private storageService: StorageService
    ) {}

    async ngOnInit() {
        try {
            const version = await lastValueFrom(
                this.http.get<IVersion>(`assets/version.json`)
            );
            if (version) {
                const buildDate = new Date(version.buildDate);
                const formattedDate =
                    buildDate.toLocaleDateString() +
                    ' ' +
                    buildDate.toLocaleTimeString();

                this.versionString.set(
                    [
                        `Version: ${version.version || 'No version'}`,
                        `Build Date: ${formattedDate}`,
                    ].join('\n')
                );
            }
        } catch (error) {}
    }

    public changeLanguage(code: string) {
        this.translate.use(code);
        this.storageService.setItem('language_code', code);
    }
}
